import store from '@/store';

const isUserAllowedRoute = (user, meta) => {
  if (user.roles?.some((role) => role.name === 'owner')) return true;
  if (meta.ownerOnly) return false;
  if (meta.permission) {
    return (user.permissions ?? []).includes(meta.permission)
      || Boolean(meta.anyPermission && (user.permissions ?? []).includes(meta.anyPermission));
  }
  return Boolean(meta.public || (meta.anyPermission && (user.permissions ?? []).includes(meta.anyPermission)));
};

const PermissionMiddleware = (to, from, next) => {
  const { currentUser } = store.state.auth;

  if (!isUserAllowedRoute(currentUser, to.meta)) {
    next('/access_denied');
    return;
  }

  next();
};

export {
  isUserAllowedRoute,
  PermissionMiddleware,
};
